<script lang="ts">
	import { Asset, Headline } from '@atoms';
	import type { CarouselBlockType } from './CarouselBlockQuery';
	import { Carousel } from '@core/builders/carousel/Carousel.svelte';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	const { data }: { data: CarouselBlockType } = $props();

	const carousel = Carousel.from([...data.images, ...data.images, ...data.images], {
		scroll: {
			pauseOnHover: false,
			auto: -2.5
		},
		drag: true
	});
	carousel.state.gap = 90;
	createViewController();
</script>

<section use:ViewController>
	{#if data.headline}
		<span use:EnterOnView>
			<Headline text={data.headline} borderTop={true} />
		</span>
	{/if}

	<div
		class="imageContainer"
		use:carousel.useContainer
		{...carousel.attr.container}
		use:EnterOnView={{ delay: 0.1 }}
	>
		{#each carousel.items as image}
			<div class="item" {...image.attr} use:image.useItem>
				<Asset data={image.data} />
			</div>
		{/each}
	</div>
</section>

<style lang="scss">
	section {
		@include pagePadding;
		@include blockPadding;
	}

	.item {
		height: 90px;
	}

	.imageContainer {
		overflow: hidden;
		display: flex;
		height: 90px;
		// margin: 0 -35px;
		flex-direction: row;
	}
</style>
